import { RouteComponent, RouteRecordRaw } from 'vue-router';

import { statisticsRoutes } from '@/router/routes/statistics/statistics.routes';
import { payoutOrderRoutes } from '@/router/routes/payout-order/payout-order.routes';
import { documentsRoutes } from '@/router/routes/documents/documents.routes';

export const DASHBOARD_ROUTE_NAME = 'dashboard';

export const routes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    children: [
      {
        name: DASHBOARD_ROUTE_NAME,
        path: '',
        component: async (): Promise<RouteComponent> => await import('@/layouts/dashboard-page/dashboard-page.vue'),
        children: [
          ...payoutOrderRoutes,
          ...documentsRoutes,
          ...statisticsRoutes,
        ],
      },
      {
        name: 'permissions',
        path: 'permissions',
        component: async (): Promise<RouteComponent> => await import('@/layouts/permissions-page/permissions-page.vue'),
      },
    ],
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: DASHBOARD_ROUTE_NAME },
  },
];
